/**
 * Tipos do domínio do Themis.
 *
 * IMPORTANTE: o Themis 2.0 lê e escreve no MESMO banco Firestore do app 1.x.
 * Por isso os tipos abaixo refletem os documentos como eles existem hoje,
 * inclusive os campos duplicados em duas grafias (`nome`/`NomeProduto`,
 * `estoqueSistema`/`EstoqueAtual`, ...) herdados da importação do ERP.
 *
 * Não "limpe" esses campos aqui. Normalize com os helpers de `produto.ts`.
 */
/** Diferença |físico - sistema| a partir da qual o item é CRITICO. */
export const LIMITE_CRITICO = 10;
//# sourceMappingURL=types.js.map